import * as React from 'react'

import FilledIcon, { FilledIconProps } from '../filled-icon/filled-icon'
import PlainCard from '../plain-card'
import { BackgroundColorVariables } from '../shared-types'
import Spacer from '../spacer'
import Text from '../text'
import styles from './card.module.scss'

export type CardProps = {
  description: string
  icon: FilledIconProps['icon']
  title: string
  backgroundColor?: BackgroundColorVariables
  iconBackgroundColor?: FilledIconProps['background']
  iconColor?: FilledIconProps['color']
} & React.ComponentPropsWithoutRef<'div'>

export default function Card({
  children,
  className,
  description,
  title,
  icon,
  backgroundColor,
  iconBackgroundColor,
  iconColor,
}: CardProps) {
  return (
    <PlainCard className={className} backgroundColor={backgroundColor}>
      <div className={styles.title}>
        <Spacer marginRight="extra-small">
          <FilledIcon
            background={iconBackgroundColor}
            icon={icon}
            color={iconColor}
          />
        </Spacer>
        <Text size="large">{title}</Text>
      </div>

      <Text marginBottom="medium" color="secondary">
        {description}
      </Text>

      {children}
    </PlainCard>
  )
}
